import { ArrowRight, Phone, Mail, MessageCircle } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { FINAL_CTA, CONTACT } from "@/data/content";
import { Words } from "@/lib/motion";
import { scrollToId } from "@/components/SmoothScroll";
import Magnetic from "@/components/Magnetic";

export default function FinalCTA() {
    const rm = useReducedMotion();
    return (
        <section className="relative py-28 md:py-40 overflow-hidden bg-ink grain" data-testid="final-cta-section">
            <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(60% 60% at 50% 30%, rgba(46,123,255,0.22), transparent 70%)" }} />
            {!rm && (
                <motion.div
                    className="sweep-line"
                    initial={{ x: "-60vw", opacity: 0 }}
                    whileInView={{ x: "120vw", opacity: [0, 1, 1, 0] }}
                    viewport={{ once: true, margin: "-20%" }}
                    transition={{ duration: 1.6, ease: [0.76, 0, 0.24, 1] }}
                />
            )}

            <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
                <p className="text-[11px] uppercase tracking-[0.35em] text-electric-soft font-body mb-8">Prêt à commencer</p>
                <h2 className="text-4xl sm:text-6xl lg:text-7xl font-light text-white leading-[1.08] font-display mb-12 text-balance">
                    <Words text={FINAL_CTA.line} />
                </h2>

                <Magnetic strength={0.4}>
                    <button
                        onClick={() => scrollToId("contact")}
                        className="group relative inline-flex items-center gap-3 bg-electric text-white px-12 py-5 text-sm uppercase tracking-[0.15em] font-semibold font-body overflow-hidden"
                        data-testid="final-cta-btn"
                        style={{ boxShadow: "0 0 40px rgba(46,123,255,0.5)" }}
                    >
                        <span className="relative z-10">{FINAL_CTA.button}</span>
                        <ArrowRight className="w-4 h-4 relative z-10 group-hover:translate-x-1 transition-transform" />
                        <span className="absolute inset-0 bg-white translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
                        <span className="absolute inset-0 flex items-center justify-center gap-3 text-navy translate-y-full group-hover:translate-y-0 transition-transform duration-300 z-10 uppercase tracking-[0.15em] font-semibold">
                            {FINAL_CTA.button} <ArrowRight className="w-4 h-4" />
                        </span>
                    </button>
                </Magnetic>

                <div className="mt-14 flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
                    <a href={`tel:${CONTACT.phone}`} className="flex items-center gap-2 text-white/70 hover:text-white text-sm font-body transition-colors">
                        <Phone className="w-4 h-4 text-electric" /> {CONTACT.phoneDisplay}
                    </a>
                    <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 text-white/70 hover:text-white text-sm font-body transition-colors">
                        <Mail className="w-4 h-4 text-electric" /> {CONTACT.email}
                    </a>
                    <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-white/70 hover:text-white text-sm font-body transition-colors">
                        <MessageCircle className="w-4 h-4 text-[#25D366]" /> WhatsApp
                    </a>
                </div>
            </div>
        </section>
    );
}
